export const NUMBER_OF_INITIAL_MATCHES_FETCHED = 12
